import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";

const inputCls = "w-full px-4 py-2.5 bg-white border border-[var(--parchment-2)] focus:border-[var(--maroon)] outline-none text-sm";

export default function TeacherDialog({ dialog, setDialog, busy, onSave, onClose }) {
  return (
    <Dialog open={!!dialog} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-serif-display text-2xl">
            {dialog?.mode === "create" ? "Nouveau professeur" : "Modifier le professeur"}
          </DialogTitle>
          <DialogDescription>Renseignez le nom, l'email, le rôle et le mot de passe du compte.</DialogDescription>
        </DialogHeader>
        {dialog && (
          <div className="space-y-3">
            <div>
              <label className="eyebrow block mb-1">Nom complet</label>
              <input className={inputCls} value={dialog.name} onChange={(e) => setDialog((s) => ({ ...s, name: e.target.value }))} placeholder="Ex. M. Durand" data-testid="teacher-name-input" />
            </div>
            <div>
              <label className="eyebrow block mb-1">Email</label>
              <input className={inputCls} type="email" value={dialog.email} onChange={(e) => setDialog((s) => ({ ...s, email: e.target.value }))} placeholder="durand@lafayette.edu" data-testid="teacher-email-input" />
            </div>
            <div>
              <label className="eyebrow block mb-1">Rôle</label>
              <select
                className={inputCls}
                value={dialog.role}
                onChange={(e) => setDialog((s) => ({ ...s, role: e.target.value }))}
                data-testid="teacher-role-select"
              >
                <option value="teacher">Professeur</option>
                <option value="assoc_admin">Professeur admin associé (étude du mercredi)</option>
              </select>
            </div>
            <div>
              <label className="eyebrow block mb-1">
                {dialog.mode === "create" ? "Mot de passe" : "Nouveau mot de passe (laisser vide pour conserver)"}
              </label>
              <input className={inputCls} type="password" value={dialog.password} onChange={(e) => setDialog((s) => ({ ...s, password: e.target.value }))} placeholder="8 caractères minimum" data-testid="teacher-password-input" />
            </div>
          </div>
        )}
        <DialogFooter>
          <button className="btn-secondary" onClick={onClose}>Annuler</button>
          <button className="btn-primary" onClick={onSave} disabled={busy} data-testid="teacher-save-btn">Enregistrer</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
